export enum DriversActions {
    SET_DRIVER = "setDriver",
    SET_SELECTED_DRIVERS = "setSelectedDrivers",
    TOGGLE_DRIVERS_PANEL = "toggleDriversPanel",
    TOGGLE_SMS_HISTORY_PANEL = "toggleSMSHistoryPanel",
    RELOAD_DRIVERS = "reloadDrivers",
    CLEAR= "clearDrivers",
    ADD_DRIVER="addDriver"
  }